import { render, staticRenderFns } from "./UserBookings.vue?vue&type=template&id=a0c79b24&scoped=true"
import script from "./UserBookings.vue?vue&type=script&lang=ts"
export * from "./UserBookings.vue?vue&type=script&lang=ts"
import style0 from "./UserBookings.vue?vue&type=style&index=0&id=a0c79b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c79b24",
  null
  
)

export default component.exports